export default __webpack_public_path__ + "static/outline2-3235c60a98b112dd71547e4593616e11.png";